"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
var React = require("react");
var Popup_style_1 = require("./Popup.style");
var Icon_1 = require("../../Icon");
exports.Popup = function (props) {
    var handleClick = props.handleClick, isDesktop = props.isDesktop, style = props.style, open = props.open, children = props.children, hideCloseButton = props.hideCloseButton;
    return (React.createElement(Popup_style_1.default.PopupBackground, { isDesktop: isDesktop, className: open ? "open" : null },
        React.createElement(Popup_style_1.default.Popup, { style: style, className: open ? "open" : null, isDesktop: isDesktop },
            React.createElement(Popup_style_1.default.CloseWrap, null, !hideCloseButton && (React.createElement(Popup_style_1.default.Close, { onClick: function () { return handleClick(); } },
                React.createElement(Icon_1.default, { icon: "times", size: 25 })))),
            React.createElement(Popup_style_1.default.Container, null, children))));
};
exports.default = exports.Popup;
//# sourceMappingURL=Popup.js.map